import { render, staticRenderFns } from "./land.vue?vue&type=template&id=00490180&scoped=true"
import script from "./land.vue?vue&type=script&lang=js"
export * from "./land.vue?vue&type=script&lang=js"
import style0 from "./land.vue?vue&type=style&index=0&id=00490180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00490180",
  null
  
)

export default component.exports